<template>
  <section v-if="brands?.length" class="brand mb-3 md:mb-10">
    <carousel
      :title="$t('home.brand.title')"
      navigator
      :data="brands"
      :gap="gap"
      swiper-container-class="mt-2 md:mt-4"
      swiper-slide-class="first:ml-3 last:mr-3 sm:first:ml-0 sm:last:mr-0"
    >
      <template #default="{ item }">
        <locale-link class="branch flex flex-col items-center gap-2 w-24 md:w-29" :to="`/regions/${regionId}/categories/${item.id}`">
          <etg-img
            class="branch-image size-20 object-cover rounded-full border border-gray-40 md:size-25"
            :src="`fn:${item.icon_image}`"
            :alt="item.name"
          />
        </locale-link>
      </template>
      <template #skeleton>
        <div class="skeleton-wrapper flex gap-2 overflow-hidden -ml-1 mt-2 md:gap-5 md:mt-4 md:ml-0">
          <div v-for="i in 7" :key="i" class="skeleton-card flex flex-col flex-none items-center gap-2 w-24 md:w-29">
            <n-skeleton class="size-20 rounded-full md:size-25" />
          </div>
        </div>
      </template>
    </carousel>
  </section>
</template>

<script lang="ts" setup>
import { NSkeleton } from 'naive-ui'
import Carousel from '@/components/common/carousel.vue'

import { useAppStore } from '@/store/app'
import { useRegionStore } from '@/store/region'

const MAX_DISPLAY_COUNT = 20

const appStore = useAppStore()
const regionStore = useRegionStore()
const { regionInfo } = storeToRefs(regionStore)

const { regionId } = useRegion()

const brands = computed(() => regionInfo.value?.brand?.slice(0, MAX_DISPLAY_COUNT))
const gap = computed(() => (appStore.isDesktopScreen ? 20 : 8))
</script>
